import { publicApi } from "./api";
import { captureAttribution } from "./attribution";

// One random id per browser tab, held in sessionStorage. No cookie, nothing
// about the person — it exists only so a share, the arrival it causes and
// whatever that visitor does next can be counted as one journey.
const VISIT = "cass_share_visit";
const SOURCE = "cass_share_source";
const DONE = "cass_share_done";

export const shareVisit = () => {
  try {
    let v = sessionStorage.getItem(VISIT);
    if (!v) {
      v = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(VISIT, v);
    }
    return v;
  } catch {
    return "";
  }
};

const once = (key) => {
  try {
    const done = JSON.parse(sessionStorage.getItem(DONE) || "[]");
    if (done.includes(key)) return false;
    sessionStorage.setItem(DONE, JSON.stringify([...done, key].slice(-50)));
    return true;
  } catch {
    return true;
  }
};

const SOCIAL_HOSTS = [
  ["linkedin", "linkedin."],
  ["facebook", "facebook."],
  ["facebook", "fb."],
  ["whatsapp", "whatsapp."],
  ["instagram", "instagram."],
  ["x", "t.co"],
  ["x", "twitter."],
  ["x", "x.com"],
];

const fromReferrer = () => {
  try {
    const host = new URL(document.referrer).hostname.toLowerCase();
    const hit = SOCIAL_HOSTS.find(([, frag]) => host.includes(frag));
    return hit ? { network: hit[0], referrer: host } : null;
  } catch {
    return null;
  }
};

/** Did this visit arrive from a shared link, and did it go anywhere afterwards? */
export const trackArrival = (path) => {
  // A beat, so the page's real title is in place rather than the shell's.
  setTimeout(() => record(path), 800);
};

const record = (path) => {
  captureAttribution(path);
  const visit = shareVisit();
  if (!visit) return;

  const params = new URLSearchParams(window.location.search);
  const tagged = params.get("utm_medium") === "share" ? params.get("utm_source") : null;
  const ref = tagged ? { network: tagged, referrer: "" } : fromReferrer();

  if (ref && once(`arrival:${path}`)) {
    try {
      sessionStorage.setItem(SOURCE, ref.network);
    } catch {
      /* private browsing — the arrival still counts */
    }
    publicApi.shareEvent({ type: "arrival", path, network: ref.network,
                           title: document.title, visit, referrer: ref.referrer });
    return;
  }

  // Already known to have arrived from a share: did they reach a page that
  // matters? That is as far as this goes — interest, not income.
  let source = "";
  try {
    source = sessionStorage.getItem(SOURCE) || "";
  } catch {
    source = "";
  }
  const worthwhile = ["/contact", "/pricing", "/insights", "/services"];
  if (source && worthwhile.some((p) => path === p || path.startsWith(`${p}/`)) && once(`onward:${path}`)) {
    publicApi.shareEvent({ type: "onward", path, network: source, title: document.title, visit });
  }
};
